var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SvgInfoPink(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "none",
    stroke: "#e1087e"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M10 6.53c-.44 0-.8-.12-1.07-.38-.27-.25-.41-.56-.41-.93s.14-.68.41-.93.62-.38 1.07-.38.78.12 1.06.35c.28.24.41.54.41.91 0 .39-.14.71-.41.97-.27.26-.62.38-1.06.38zm-1.17 9.2V8.66h2.34v7.07H8.83z",
    fill: "#e1087e"
  })));
}
export default SvgInfoPink;